import { DocumentNode, gql } from '@apollo/client';
import {
  Center,
  Link,
  Text,
  Wrap,
  WrapItem,
  WrapProps,
} from '@chakra-ui/react';
import NextLink from 'next/link';
import * as React from 'react';

import { usePermissions } from '@/hooks/usePermissions';
import { TagIcon } from '@/imports/ui/chakra/feather';

import { Tags_PostFragment } from './graphql-types/Tags_PostFragment';

const POST_FRAGMENT = gql`
  fragment Tags_PostFragment on PostV2 {
    _id
    tags {
      _id
      name
    }
  }
`;

export const Tags: React.FC<{ post: Tags_PostFragment } & WrapProps> & {
  postFragment: DocumentNode;
} = ({ post, ...wrapProps }) => {
  const { canAccessCommunityAndGroupFeed } = usePermissions();

  if (!post.tags?.length) {
    return null;
  }

  return (
    <Wrap spacing="2" width="full" {...wrapProps}>
      {post.tags?.map((tag) => (
        <WrapItem key={tag._id}>
          {canAccessCommunityAndGroupFeed ? (
            <Link
              as={NextLink}
              href={`/community/tags/${tag._id}`}
              textStyle="compact"
            >
              <TagIcon color="gray.800" mr="1" />
              {tag.name}
            </Link>
          ) : (
            <Center>
              <TagIcon color="gray.800" mr="1" />
              <Text as="span" textStyle="compact" color="gray.800">
                {tag.name}
              </Text>
            </Center>
          )}
        </WrapItem>
      ))}
    </Wrap>
  );
};

Tags.postFragment = POST_FRAGMENT;
